import { createBoundContext } from '@bonusly/ds-utils';

import { DateRange, DateValue } from '../types';

type DatePickerContextValue = {
	isClearable?: boolean;
	disableDateIf?: (date: Date) => boolean;
	displayFormat: 'short' | 'long';
	interimValue: DateValue | DateRange;
	isOpen: boolean;
	month: Date;
	onApply: () => void;
	onClear: () => void;
	onClose: () => void;
	onGotoToday: () => void;
	onHoverDate: (date: Date) => void;
	onNextMonth: () => void;
	onOpen: () => void;
	onPrevMonth: () => void;
	onSelectDate: (value: DateValue) => void;
	selectionEnd: DateValue;
	selectionStart: DateValue;
	setRange?: (value: any) => void;
	value: DateValue | DateRange;
};

export const [DatePickerContext, useDatePickerContext] = createBoundContext<DatePickerContextValue>({
	defaultValue: {
		isClearable: false,
		displayFormat: 'long',
		interimValue: null,
		isOpen: false,
		month: new Date(),
		onApply: () => void 0,
		onClear: () => void 0,
		onClose: () => void 0,
		onGotoToday: () => void 0,
		onOpen: () => void 0,
		onHoverDate: () => void 0,
		onSelectDate: () => void 0,
		onNextMonth: () => void 0,
		onPrevMonth: () => void 0,
		selectionEnd: null,
		selectionStart: null,
		value: null,
	},
	providerName: 'DatePickerContext',
	hookName: 'useDatePickerContext',
});
